module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g4wSv"))).then(() => module.bundle.root('ljYL6'));